// KPW: randomize collection grid display without hiding sold-out items.
(function () {
  function shuffle(nodes) {
    for (var i = nodes.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = nodes[i];
      nodes[i] = nodes[j];
      nodes[j] = tmp;
    }
    return nodes;
  }

  function shouldSkip(url) {
    if (!/^\/collections\/[^\/]+/.test(url.pathname)) return true;
    if (url.searchParams.has('sort_by')) return true;
    if (url.searchParams.has('page')) return true;

    var skip = false;
    url.searchParams.forEach(function (_value, key) {
      if (key.indexOf('filter.') === 0) skip = true;
    });
    return skip;
  }

  function randomizeCollectionGrid() {
    try {
      var url = new URL(window.location.href);
      if (shouldSkip(url)) return;

      var grid = document.querySelector('.collection-content .grid--uniform');
      if (!grid) return;

      var items = Array.prototype.slice.call(grid.children).filter(function (item) {
        return item.classList && item.classList.contains('grid-product');
      });
      if (items.length < 2) return;

      shuffle(items).forEach(function (item) {
        grid.appendChild(item);
      });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', randomizeCollectionGrid);
  } else {
    randomizeCollectionGrid();
  }
})();
